var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import { selectShipmentData } from "../../../../redux/packing";
import { useTranslation } from "react-i18next";
export var ShippingInstructionsBanner = function () {
    var _a;
    var t = useTranslation().t;
    var shipmentData = useSelector(selectShipmentData);
    return ((_a = shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.orderPart) === null || _a === void 0 ? void 0 : _a.shippingInstructions) ? (_jsxs("div", __assign({ className: 'rounded-lg border border-yellow-100 bg-yellow-50 p-3 mt-4' }, { children: [_jsx("p", __assign({ className: 'mb-1 text-xs font-bold uppercase text-yellow-800' }, { children: t('Shipping Instructions') }), void 0), _jsx("p", __assign({ className: 'text-xs text-yellow-700' }, { children: shipmentData.orderPart.shippingInstructions }), void 0)] }), void 0)) : null;
};
